import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'activated'
})
export class ActivatedPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    var result = "";
    if(value === 1){
      result = "啟用";
    }else if (value === 0){
      result = "未啟用";
    }
    return result;
  }

}
